import React from "react";

const FolderIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.88627 0.998132C3.49772 0.779951 4.16097 0.7524 4.78841 0.91912C5.41585 1.08584 5.97794 1.43898 6.40044 1.9319C6.82295 2.42482 7.08597 3.03431 7.15477 3.67987C7.22356 4.32542 7.0949 4.97666 6.78577 5.54755L16.6023 15.3651L15.3062 16.6612L5.48868 6.84372C4.91767 7.15163 4.26676 7.27931 3.62174 7.20993C2.97671 7.14054 2.36785 6.87736 1.87538 6.45506C1.3829 6.03276 1.02994 5.47115 0.862994 4.84426C0.69605 4.21736 0.722961 3.5546 0.940182 2.9433L2.99077 4.99388C3.1176 5.12521 3.26933 5.22996 3.43708 5.30202C3.60484 5.37408 3.78527 5.41202 3.96784 5.4136C4.15041 5.41519 4.33147 5.3804 4.50045 5.31126C4.66943 5.24213 4.82296 5.14003 4.95206 5.01093C5.08116 4.88182 5.18326 4.7283 5.2524 4.55932C5.32153 4.39034 5.35632 4.20928 5.35473 4.02671C5.35315 3.84413 5.31522 3.66371 5.24316 3.49595C5.17109 3.3282 5.06634 3.17647 4.93502 3.04963L2.88535 0.997216L2.88627 0.998132ZM12.3893 2.72513L15.3062 1.10447L16.6023 2.40063L14.9817 5.31747L13.361 5.64197L11.4177 7.58622L10.1206 6.29005L12.0648 4.3458L12.3893 2.72513ZM6.23118 10.1795L7.52735 11.4756L2.66627 16.3367C2.50099 16.5025 2.27857 16.5987 2.04461 16.6057C1.81065 16.6127 1.58287 16.53 1.40797 16.3744C1.23307 16.2188 1.12431 16.0023 1.10397 15.7691C1.08363 15.5359 1.15327 15.3038 1.2986 15.1203L1.3701 15.0406L6.23118 10.1795Z"
        fill="#B6B5BB"
      />
    </svg>
  );
};

export default FolderIcon;
